const Properties = {
    SERVER_LINK: import.meta.env.VITE_APP_SERVER_LINK,
    CLOUD_STORAGE_ENDPOINT: import.meta.env.VITE_APP_CLOUD_STORAGE_ENDPOINT,
};

export default Properties
  